import React from "react";
import "./CustomPagination.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

function CustomPagination({ currentPage, totalPages, handlePageChange }) {

  const goPrev = () => {
    if (currentPage > 1) {
      handlePageChange(currentPage - 1);
    }
  };

  const goNext = () => {
    if (currentPage < totalPages) {
      handlePageChange(currentPage + 1);
    }
  };
  return (
    <div className="CustomPagination">
      <div className="pagination-box">

        <button className="arrow-btn left" onClick={goPrev}
          disabled={currentPage === 1}>
          <FaChevronLeft />
        </button>

        <span className="page-count"> {currentPage}/{totalPages}</span>

        <button className="arrow-btn right" onClick={goNext}
          disabled={currentPage === totalPages}>
          <FaChevronRight />
        </button>

      </div>
    </div>
  );
}

export default CustomPagination;